import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminCourseCategories,
} from "../../api/admin/courseCategory.api";

/* ============================================================
   FETCH COURSE CATEGORIES
============================================================ */

export const fetchCourseCategories = createAsyncThunk(
  "admin/courseCategory/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAdminCourseCategories();

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message ||
          "Failed to fetch course categories."
      );
    }
  }
);